import {Roi} from 'api/analysisApi'

export const TYPE_REPORT = {
  BRAIN_FUNCTION_MAPPING: 1,
  FIVE_INDICATORS: 2,
  BRAIN_FUNCTION_CONNECTIVITY: 3,
}

export const REANALYSIS_REPORT_TYPE = {
  BASIC: 1,
  FIVE_INDICATORS: 3,
  CONNECTIVITY: 4,
}

export const REANALYSIS_REPORT_OPTIONS_HEALTH = [
  {
    key: REANALYSIS_REPORT_TYPE.BASIC,
    label: 'IBrainFunctionMappingBasic',
  },
]

export const REANALYSIS_REPORT_OPTIONS = [
  ...REANALYSIS_REPORT_OPTIONS_HEALTH,
  {
    key: REANALYSIS_REPORT_TYPE.FIVE_INDICATORS,
    label: 'IBrainFunctionIndicators',
  },
  {
    key: REANALYSIS_REPORT_TYPE.CONNECTIVITY,
    label: 'IBrainFunctionConnectivity',
  },
]

export const EEG_SUMMARY_TABS_HEALTH = [
  {id: TYPE_REPORT.BRAIN_FUNCTION_MAPPING, label: 'IBrainFunctionMapping'},
]

export const EEG_SUMMARY_TABS = [
  ...EEG_SUMMARY_TABS_HEALTH,
  {id: TYPE_REPORT.FIVE_INDICATORS, label: 'IBrainFunctionIndicators'},
  {
    id: TYPE_REPORT.BRAIN_FUNCTION_CONNECTIVITY,
    label: 'IBrainFunctionConnectivity',
  },
]

export const SUMMARY_REPORT_TYPE = 'reportService'

export const INIT_HRV_SUMMARY_ANALYSIS_REPORT = {
  final_report_path: '',
  images: {
    circular: '',
    contour: '',
    histogram: '',
    table: '',
  },
  scores: {
    anxiety_level: 0,
    auto_nervous_system_balance: {
      parasympathetic: 0,
      sympathetic: 0,
    },
    circular_level: 0,
    contour_level: 0,
    depression_level: 0,
    gas_phase_level: 0,
    histogram_level: 0,
  },
}

export const INIT_BRAIN_CONNECTIVITY_ANALYSIS_REPORT = {
  final_report_path: '',
  measured_time: {
    eeg_ec: 0,
    eeg_eo: 0,
    hrv: 0,
  },
  scores: {
    total: 0,
    intra: {
      frontal: {
        left: 0,
        right: 0,
      },
      pariocci: {
        left: 0,
        right: 0,
      },
    },
    inter: {
      vertical: {
        left: 0,
        right: 0,
      },
      horizontal: 0,
    },
  },
  images: {
    total_connection: '',
  },
}

export const INIT_TOP_INDICATORS_ANALYSIS_REPORT = {
  final_report_path: '',
  images: {
    radar_chart: '',
  },
  measured_time: {
    eeg_ec: 0,
    eeg_eo: 0,
    hrv: 0,
  },
  scores: {
    sadness: 0,
    tension: 0,
    stress: 0,
    dominant_frequency: {
      value: 0,
      score: 0,
    },
    inanttention: {
      value: 0,
      score: 0,
    },
  },
}

export const INIT_EEG_SUMMARY_ANALYSIS_REPORT = {
  final_report_path: '',
  images: {
    alpha_development_bar_graph: '',
    alpha_development_line_graph: '',
    brain_age_graph: '',
    brain_aging_3D: '',
    brain_aging_contour: '',
    brain_balance: '',
    brain_balance_3D: '',
    frontal_development_graph: '',
    processing_speed_graph: '',
  },
  scores: {
    brain_mapping: {
      total_score: 0,
      lobe_scores: {
        Frontal_LH: 0,
        Frontal_RH: 0,
        Parietal_LH: 0,
        Parietal_RH: 0,
        Occipital_LH: 0,
        Occipital_RH: 0,
        Temporal_LH: 0,
        Temporal_RH: 0,
      },
      roi_scores: {} as Roi,
    },
    infant_youth: {
      frontal_development: {
        sensor_tbr_cz: 0,
        percentile: 0,
      },
      information_processing_speed: {
        occipital_alpha_peak_freq: 0,
        percentile: 0,
      },
      alpha_development: {
        ec_alpha_proportion: 0,
        eo_alpha_proportion: 0,
        ec_alpha_proportion_normal: 0,
        eo_alpha_proportion_normal: 0,
        ec_alpha_proportion_percentile: 0,
        eo_alpha_proportion_percentile: 0,
      },
      brain_balance: {
        LH: 0,
        RH: 0,
      },
      brain_age: {
        avg: 0,
        by_lobe: {
          Frontal_LH: 0,
          Frontal_RH: 0,
          Parietal_LH: 0,
          Parietal_RH: 0,
          Occipital_LH: 0,
          Occipital_RH: 0,
          Temporal_LH: 0,
          Temporal_RH: 0,
        },
        subject_age: 0,
      },
    },
  },
}
